import { inject, PLATFORM_ID } from '@angular/core';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, map } from 'rxjs/operators';

import * as fromStore from '../store';

import { of } from 'rxjs';
import { isPlatformServer } from '@angular/common';
import { CanActivateFn } from '@angular/router';

export const InsightCodeGuard: CanActivateFn = () => {
  const store = inject(Store);
  const platformId = inject(PLATFORM_ID);

  if (isPlatformServer(platformId)) {
    return of(true);
  }
  return store.select(fromStore.getInsightCodeInitialized).pipe(
    tap(loaded => {
      if (!loaded) {
        store.dispatch(fromStore.InitInsightCode());
      }
    }),
    filter(loaded => loaded),
    map(loaded => loaded),
    take(1),
    switchMap(() => of(true)),
    catchError(() => of(false))
  );
};
